export default {
  HEADERBAR_HEIGHT: 64,
  HEADERBAR_HEIGHT_XL: 64,
  HEADERBAR_HEIGHT_LG: 64,
  HEADERBAR_HEIGHT_MD: 64,
  HEADERBAR_HEIGHT_SM: 64,
  HEADERBAR_HEIGHT_XS: 64,
  SIDEBAR_WIDTH: 256,
  SIDEBAR_WIDTH_XL: 256,
  SIDEBAR_WIDTH_LG: 256,
  SIDEBAR_WIDTH_MD: 256,
  SIDEBAR_WIDTH_SM: 256,
  SIDEBAR_WIDTH_XS: 240,
  //FILTER_SIDE_BAR_WIDTH: 352,
  FILTER_SIDE_BAR_WIDTH_XL: 340,
  FILTER_SIDE_BAR_WIDTH_LG: 320,
  FILTER_SIDE_BAR_WIDTH_MD: 300,
  FILTER_SIDE_BAR_WIDTH_SM: 280,
  FILTER_SIDE_BAR_WIDTH_XS: 260,
  //SILDER_COMPOUND_TRACK_HEIGHT: 3,
  //SILDER_COMPOUND_HANDLE_HEIGHT: 20,
  SUPPLIER_TAB_PADDING_LEFT: 45,
  SUPPLIER_TAB_PADDING_LEFT_XXL: 45,
  SUPPLIER_TAB_PADDING_LEFT_XL: 35,
  SUPPLIER_TAB_PADDING_LEFT_LG: 25,
  SUPPLIER_TAB_PADDING_LEFT_MD: 20,
  SUPPLIER_TAB_PADDING_LEFT_SM: 15,
  SUPPLIER_TAB_PADDING_LEFT_XS: 10,
}
